export const GET_CCENTERS_SUCCESS = "GET_CCENTERS_SUCCESS";
export const GET_CCENTER_SUCCESS  = "GET_CCENTER_SUCCESS";
export const GET_REQUEST_SUCCESS  = "GET_REQUEST_SUCCESS";
export const GET_REQUEST_ERROR    = "GET_REQUEST_ERROR";
